import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[jhiEllipsis]',
})
export class EllipsisDirective implements AfterViewInit {
  @Input('jhiEllipsis') subjectContect!: string;

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    const element = this.elementRef.nativeElement;
    const maxLength = 10;
    const text = String(element.textContent);

    if (text.length > maxLength) {
      const truncatedText = text.substring(0, maxLength) + '...';
      element.textContent = truncatedText;

      const iconElement = document.createElement('mat-icon');
      iconElement.classList.add('mat-icon', 'material-icons', 'material-symbols-outlined');
      iconElement.setAttribute('aria-hidden', 'true');
      iconElement.setAttribute('title', this.subjectContect);
      iconElement.textContent = 'info';
      element.appendChild(iconElement);
    }
  }
}
